const SKU = "/sku";

export const GET_SKU_CATEGORIES = `${SKU}/getAllInventorySkuCategoriesWithSkuSubCategories`;

export const GET_SKU_DETAILS = `${SKU}/:skuId/getSkuDetailsForMechanicApp`;

export const GET_SKU_SUBCATEGORIES = `${SKU}/getAllSkuSubCategoriesApplyingMechanicAppRules/:categoryId`;

export const GET_SKUS = `${SKU}/getAllSkusApplyingMechanicAppRules`;

export const GET_SKU_BRANDS = `${SKU}/getAllSkuBrandsInWarehouse`;

export const GET_NEW_SKUS = `${SKU}/getAllNewlyAddedSkusForMechanicApp`;

export const GET_RECOMMENDED_SKUS = `${SKU}/getAllRecommendedSkusApplyingMechanicAppRules`;

export const GET_RELEVANT_SKUS = `${SKU}/getRelevantSkuList/:skuId`;

export const GET_SUBSTITUTE_SKUS = `${SKU}/getSubstituteSkuList/:skuId`;

export const checkSkusMatchingCar = `${SKU}/checkSkusMatchingCar`;

export const LOG_OUT_OF_STOCK = `${SKU}/logSkuOutOfStockForMechanic`;

export const LOG_SKU_OUT_OF_STOCK_QUANTITY = `${SKU}/logSkuOutOfStockQuantityForMechanic`;
